module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin,
      "barColor": _vm.barColor
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Top Bowlers: By Wickets")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes top 10 bowlers by total number of wickets taken\n      across all IPL seasons.\n    ")]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Lasith Malinga of Mumbai Indians leads the chart with 143 wickets taken.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Amit Mishra of Delhi Daredevils comes second with 124 wickets.\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fc4cb7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/BowlerTotalWickets.vue
// module id = 393
// module chunks = 1